import { MapboxVectorLayer } from 'ol-mapbox-style';

export function createSitgBaseLayer(visible: boolean) {
  return new MapboxVectorLayer({
    styleUrl: 'https://vector.sitg.ge.ch/arcgis/rest/services/Hosted/PLAN_SITG_EPSG3857/VectorTileServer/resources/styles/root.json?f=json',
    visible,
    properties: { name: 'base_sitg' },
  });
} 